// `/accounts` index — mounts the LinkedIn Accounts list view.

import { createRoute } from '@tanstack/react-router';

import { AccountsListPage } from '@/features/accounts/AccountsListPage';

import { Route as AccountsLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => AccountsLayoutRoute,
  path: '/',
  component: AccountsListPage,
});
